var _path, _circle, _circle2, _circle3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#366CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M33 12.5H18M33 22.5H18M33 32.5H18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 1.5,
    fill: "#366CC8",
    transform: "rotate(90 12.5 12.5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 22.5,
    r: 1.5,
    fill: "#366CC8",
    transform: "rotate(90 12.5 22.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 32.5,
    r: 1.5,
    fill: "#366CC8",
    transform: "rotate(90 12.5 32.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    x: 1.5,
    y: 1.5,
    stroke: "#366CC8",
    strokeWidth: 3,
    rx: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecklist);
export default __webpack_public_path__ + "static/media/icon-checklist.b9300da0.svg";
export { ForwardRef as ReactComponent };